<header class="w-full bg-background">
  <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
    <!-- Logo -->
    <div class="flex items-center">
      <img [src]="imageSrc()" alt="Esignatur" class="h-8" />
    </div>

    <!-- Language selector -->
    <div class="flex items-center">
      <esignatur-language-dropdown />
    </div>
  </div>
</header>
